import { apiSlice } from '../../api/apiSlice';
import { 
    ALL_PARENT_CLIENTS, 
    CHECK_METRIC_NAME,
    CREATE_METRIC, 
    GET_METRIC_BY_ID,
    GET_METRIC_CATEGORIES, 
    GET_METRIC_FREQUENCIES, 
    GET_METRIC_TYPES, 
    GET_METRICS, 
    UPDATE_METRIC,
    PARSE_FORMULA
} from '../../constants';

export const metricsAdminSlice : any = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getAllParentClients: builder.query({
            query: () => {
                return {
                    url: ALL_PARENT_CLIENTS,
                };
            },
        }),
        getMetrics: builder.query({
            query: (args: any) => {
                const { parentClientId, globalMetrics } = args;
                return {
                    url: GET_METRICS,
                    params: { parentClientId, globalMetrics },
                };
            },
            providesTags: ['Metrics'],
        }),
        getMetricCategories: builder.query({
            query: () => {
                return {
                    url: GET_METRIC_CATEGORIES,
                };
            },
        }),
        getMetricFrequencies: builder.query({
            query: () => {
                return {
                    url: GET_METRIC_FREQUENCIES,
                };
            },
        }),
        getMetricTypes: builder.query({
            query: () => {
                return {
                    url: GET_METRIC_TYPES,
                };
            },
        }),
        getMetricById: builder.query({
            query: (metricId: number) => {
                return {
                    url: `${GET_METRIC_BY_ID}/${metricId}`,
                };
            },
            providesTags: (result: any, error: any, metricId: number) => [
                { type: 'Metrics', id: metricId }
            ],
        }),
        createMetric: builder.mutation({
            query: (metricData: any) => ({
                url: CREATE_METRIC,
                method: 'POST',
                body: metricData,
            }),
            invalidatesTags: ['Metrics'],
        }),
        updateMetric: builder.mutation({
            query: (metricData: any) => ({
                url: UPDATE_METRIC,
                method: 'PUT',
                body: metricData,
            }),
            invalidatesTags: ['Metrics'],
        }),
        // ADD THIS NEW ENDPOINT
        parseFormula: builder.mutation({
            query: (formula: string) => ({
                url: PARSE_FORMULA,
                method: 'POST',
                body: { formula },
            }),
        }),
        checkMetricName: builder.query({
            query: ({ name, excludeMetricId }: { name: string; excludeMetricId?: number | null }) => ({
                url: CHECK_METRIC_NAME,
                params: {
                    name,
                    ...(excludeMetricId != null && { excludeMetricId }),
                },
            }),
        }),
    }),
});

export const {
    useGetAllParentClientsQuery,
    useGetMetricsQuery,
    useGetMetricCategoriesQuery,
    useGetDataSourcesQuery,
    useGetMetricFrequenciesQuery,
    useGetMetricTypesQuery,
    useGetMetricByIdQuery,
    useCreateMetricMutation,
    useUpdateMetricMutation,
    useParseFormulaMutation,
    useLazyCheckMetricNameQuery,
} = metricsAdminSlice;